const STRUCTURAL_TAGS = ['P', 'DIV', 'H1', 'B', 'STRONG', 'OL', 'UL', 'LI'];
const LIST_TAGS = ['OL', 'UL', 'LI'];

/**
 * Formatting a pasted or loaded node may keep: headings, bold and list type.
 * Everything else (colour, font, size, links) is dropped. Quill runs the OL/UL
 * matcher after its LI children, so list containers must keep the list type too,
 * or a saved bullet list comes back as plain paragraphs.
 */
export function keepStructuralAttributes(tagName, attributes) {
  if (!attributes || !STRUCTURAL_TAGS.includes(tagName)) return undefined;
  const kept = {};
  if (tagName === 'H1') kept.header = 1;
  if (attributes.bold || tagName === 'B' || tagName === 'STRONG') kept.bold = true;
  if (LIST_TAGS.includes(tagName) && attributes.list) kept.list = attributes.list;
  return Object.keys(kept).length > 0 ? kept : undefined;
}

export default keepStructuralAttributes;
